import { Link } from '@tanstack/react-router';
import type { DemoPersona } from '@/lib/auth';

/**
 * Above the top bar while a demo persona is signed in (ADR-0020): the companies are samples shared
 * with other visitors, changes are kept until the next reset, and the other persona is one click
 * away.
 */
export function DemoBanner({ persona }: { persona: DemoPersona }) {
  const other: DemoPersona = persona === 'owner' ? 'accountant' : 'owner';
  return (
    <div
      role="status"
      data-testid="demo-banner"
      className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 border-b bg-brand-blue-50 px-4 py-2 text-center text-sm text-brand-navy"
    >
      <span>
        <strong className="font-semibold">
          You are in the demo as {persona === 'owner' ? 'a business owner' : 'an accountant'}
        </strong>{' '}
        with sample companies shared with other visitors. Post anything; the books are reset from
        time to time.
      </span>
      <Link
        to="/demo"
        search={{ as: other }}
        reloadDocument
        className="font-semibold text-primary hover:underline"
      >
        Switch to {other === 'owner' ? 'business owner' : 'accountant'}
      </Link>
      <Link to="/signup" className="font-semibold text-primary hover:underline">
        Create your account
      </Link>
    </div>
  );
}
